import React from "react";
import data from "../Data/Data";
import Btn from "../../../ReUseAbleComp/Button.jsx";
import Header from "../../../ReUseAbleComp/Header.jsx";
import Search from "../../../ReUseAbleComp/SearchInput.jsx";

function LGEnglish({
  searchTagPashto,
  CovidsearchTerm,
  CovidPashtoSearch,
  handleCovidChange,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Header
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
      <br />
      <br />
      <br />
      <br />
      <center>
        <h1>کروناوایرس</h1>

        <Search
          handleChange={handleCovidChange}
          searchTerm={CovidsearchTerm}
          searchTagPashto={searchTagPashto}
          dir="rtl"
        />

        {CovidPashtoSearch.map((item) => (
          <Btn
            key={item.id}
            bool={true}
            title={item.Ptitle}
            id={item.RID}
            path={`/CovidPashtoDetails/${item.id}`}
          />
        ))}
      </center>
    </>
  );
}

export default LGEnglish;
